import React from 'react';
import ReactDOM from 'react-dom';
import {
  HashRouter as Router,
  Switch,
  Route,
  useHistory,
} from "react-router-dom";
import firebase from "firebase/app";
import "firebase/analytics";
import CssBaseline from "@material-ui/core/CssBaseline";

import { ThemeProvider } from '@material-ui/core/styles';
// import "./i18n";
import theme from './assets/theme';
import StoreRegister from './StoreRegister';
import CustomerRegister from './CustomerRegister';
import Home from './Home';
import Login from './Login';
import ForgotPassword from './ForgotPassword';
import RegisiterRecord from './admin/RegisiterRecord';
import StoreProfile from './admin/StoreProfile';
import ChangePassword from './admin/ChangePassword'
import QrcodeChecking from './QrcodeChecking';
import NoMatch from './NoMatch';
// import reportWebVitals from './reportWebVitals';
import Config from './config';

firebase.initializeApp(Config.firebaseConfig);
const analytics = firebase.analytics;

const logCurrentPage = () => {
  analytics().setCurrentScreen(window.location.pathname);
  analytics().logEvent(window.location.pathname);
};

const AnalyticsComponent = () => {
  const history = useHistory();
  React.useEffect(() => {
    logCurrentPage(); // log the first page visit
    history.listen(() => {
      logCurrentPage();
    });
  }, [history]);
  return (
    <Switch>
      <Route path="/" exact>
        <Home />
      </Route>
      <Route path="/login" exact>
        <Login />
      </Route>
      <Route path="/password" exact>
        <ForgotPassword />
      </Route>
      <Route path="/admin/qrcode" exact>
        <StoreProfile />
      </Route>
      <Route path="/admin/regisiterrecords" exact>
        <RegisiterRecord />
      </Route>
      <Route path="/admin/changePassword" exact>
        <ChangePassword />
      </Route>
      <Route exact path="/qrcode/:uuid">
        <QrcodeChecking />
      </Route>
      <Route exact path="/regisiter/:registrationId?">
        <StoreRegister analytics={analytics} />
      </Route>
      <Route exact path="/checkin/:storeId?/:tableId?/:validationCode?/:tableCode?">
        <CustomerRegister analytics={analytics} />
      </Route>
      <Route path="*">
        <NoMatch />
      </Route>
    </Switch>
  );
};

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <Router>
      <AnalyticsComponent />
    </Router>
  </ThemeProvider>,
  document.getElementById('root')
);

// reportWebVitals();
